
<main>
  <BotAlerts />
  <router-view />
</main>
